/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid } from '@mui/material';
import React, { useState } from 'react';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackReturnAsset: (data: any) => void;
  returnassetDetails: any;
  trans?: any;
}
const ReturnAssetModalPresenter = ({
  isModalOpen,
  closeModal,
  returnassetDetails,
  callBackReturnAsset,
  trans,
}: ModalProps) => {
  const [reason, setReason] = useState('');
  const [assetRemarks, setAssetRemarks] = useState('');
  const handleSubmit = () => {
    callBackReturnAsset({
      returnReason: reason,
      remarks: assetRemarks,
      assetId: returnassetDetails?.id,
    });
    closeModal();
  };
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="400px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Return Asset') }}
        closeModal={closeModal}
      />
      <Grid
        container
        spacing={2}
        style={{
          marginTop: '10px',
        }}
      >
        <Grid item xs={12}>
          <CustomTextField
            type=""
            label={trans('Reason')}
            placeholder={trans('Write Reason')}
            value={reason}
            onChange={(e: any) => setReason(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            type=""
            label={trans('Remarks')}
            placeholder={trans('Write Remarks')}
            value={assetRemarks}
            onChange={(e: any) => setAssetRemarks(e.target.value)}
          />
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};
export default ReturnAssetModalPresenter;
